module.exports = __webpack_public_path__ + "media/application/images/ui/icon-facebook-12b7987846f9a4db526139879f9cc72a.png";